<template>
  <div>
    <b-container fluid id="nomalInfoContainer">
      <b-row>
        <b-col>
          <b-form @submit="onSubmit">
            <b-form-group id="input-group-1" label-for="input-1">
              <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                required
                placeholder="請輸入信箱"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="form.cellPhone"
                type="number"
                required
                placeholder="請輸入手機"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-container fluid>
                <b-row>
                  <b-col cols="6" style="padding-left: 0px;">
                    <b-button type="submit" variant="danger" block>查詢</b-button>
                  </b-col>
                  <b-col cols="6" style="padding-right: 0px;">
                    <b-button variant="danger" @click="goToCreateLead()" block>新增名單</b-button>
                  </b-col>
                </b-row>
              </b-container>
            </b-form-group>
            <b-form-group v-if="displayQueryResult">
              <b-card
                no-body
                header-bg-variant="danger"
                header-text-variant="white"
                :header="queryReasult.ChineseName"
              >
                <b-list-group flush>
                  <b-list-group-item button @click="goToMobileLeadInfoView()">
                    <b-container>
                      <b-row>
                        <b-col cols="5">名單資訊</b-col>
                        <b-col cols="7">
                          <b-img
                            src="../../../static/img/open_in_new.png"
                            alt="user-img"
                            style="height: 24px;"
                          ></b-img>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-list-group-item>
                  <b-list-group-item>
                    <b-container>
                      <b-row>
                        <b-col cols="5">品牌</b-col>
                        <b-col cols="7">{{queryReasult.Brand}}</b-col>
                      </b-row>
                    </b-container>
                  </b-list-group-item>
                  <b-list-group-item>
                    <b-container>
                      <b-row>
                        <b-col cols="5">目前狀態</b-col>
                        <b-col cols="7">{{queryReasult.StatusDesc}}</b-col>
                      </b-row>
                    </b-container>
                  </b-list-group-item>
                  <b-list-group-item>
                    <b-container>
                      <b-row>
                        <b-col cols="5">主聯業務</b-col>
                        <b-col cols="7">{{queryReasult.MainContactName}}</b-col>
                      </b-row>
                    </b-container>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-form-group>
            <b-form-group v-if="displayQueryResult" style="text-align:center;">
              <b-button variant="danger" @click="bindLeadAndSocialLead()">綁定</b-button>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { LeadHandler } from "@/handler/LeadHandler.js";
import { Loading } from "element-ui";
import store from "@/vuex/store_lead.js";
export default {
  props: ["socialLeadId", "tutorChatToken"],
  data() {
    return {
      queryReasult: [],
      displayQueryResult: false,
      bindReasult: "",
      form: {
        email: "",
        cellPhone: ""
      }
    };
  },
  created() {
    this.form.email = store.state.bindInfo.email;
    this.form.cellPhone = store.state.bindInfo.cellPhone;
    if (this.form.email != "" && this.form.cellPhone != "") {
      this.queryLeadInfo();
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.queryLeadInfo();
    },
    queryLeadInfo: function() {
      let loadingInstance = Loading.service({ fullscreen: true });
      this.queryReasult = LeadHandler.queryLeadInfo(
        this.form,
        this.tutorChatToken
      );
      loadingInstance.close();
      if (this.queryReasult != null) {
        this.displayQueryResult = true;
        //為了查詢出來之後按下名單資訊，之後再按上一頁回來綁定這個情境無法保留查詢結果，創一個stage來保存。
        store.dispatch("saveBindInfo", this.form);
      } else {
        alert("查無資料。");
      }
    },
    goToCreateLead: function() {
      window.location.href =
        "#/MobileCreateLeadView?tct=" + this.tutorChatToken;
    },
    goToMobileLeadInfoView: function() {
      window.location.href =
        "#/MobileLeadInfoView?ls=" +
        this.queryReasult.LeadSn;
    },
    bindLeadAndSocialLead: function() {
      let loadingInstance = Loading.service({ fullscreen: true });
      this.bindReasult = LeadHandler.bindLeadAndSocialLead(
        this.socialLeadId,
        this.queryReasult,
        this.tutorChatToken,
        false
      );
      loadingInstance.close();
      alert(this.bindReasult);
    }
  }
};
</script>

<style scoped>
#nomalInfoContainer {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 15px 15px 0;
}

.btn {
  float: right;
  font-size: 13px;
  background: #b20404;
}

.card {
  font-size: 13px;
  margin-top: 15px;
}

.card-header {
  background: #989898 !important;
  padding: 10px 15px;
}

.list-group-item {
  padding: 10px 15px;
}

.list-group-item .col-7 {
  text-align: right;
}

.form-control {
  border-color: #e8e8e8;
  font-size: 15px;
  padding: 10px;
}
.form-control:focus {
  box-shadow: none;
}

.list-group-item .col-5,
.list-group-item .col-7 {
  padding: 0px;
}

.form-group {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/BindLeadAndSocialLead.vue